<template>
  <div v-if="show">
    <span style="font-weight:bold;color:red;">组件名称：{{data.componentChineseName ? data.componentChineseName : data.name}}</span>
    <el-form label-position="top" size="mini">
    	<el-form-item label="数据绑定Key">
        <el-input v-model="data.model"></el-input>
      </el-form-item>
    	<el-form-item v-for="(item,index) in data.options"
                    :label="item.title"
                    :key="index">

    		<template v-if="item.attrName == 'defaultRateValue'">
        	<el-rate style="display:inline-block;vertical-align: middle;"
                   :max="data.options.filter(x => x.attrName == 'max')[0].value"
                   :allow-half="data.options.filter(x => x.attrName == 'allowHalf')[0].value"
                   v-model="item.value"></el-rate>
          <el-button type="text" style="display:inline-block;vertical-align: middle;margin-left: 10px;" @click="item.value=0">清空</el-button>
        </template>
        
        <template v-else-if="item.attrName == 'defaultColorValue'">
        	<el-color-picker v-model="item.value" :show-alpha="data.options.filter(x => x.attrName == 'showAlpha')[0].value"></el-color-picker>
        </template>
        
        <template v-if="item.attrName == 'defaultTimeValue'">
        	<el-time-picker 
            key="1"
            style="width: 100%;"
            v-if="!data.options.filter(x => x.attrName == 'isRange')[0].value"
            v-model="data.options.filter(x => x.attrName == 'defaultTimeValue')[0].value"
            :arrowControl="data.options.filter(x => x.list && x.list.length > 0 && x.attrName == 'attr')[0].list.filter(el => el.attrName == 'arrowControl')[0].value"
            :value-format="data.options.filter(x => x.attrName == 'format')[0].value"
          >
          </el-time-picker>
        </template>
        
        <template v-else-if="item.attrName == 'dynamicChange'">
      		<div v-for="(el,j) in item.list" :key="j">
	        	<el-radio-group v-model="el.value" v-if="el.type == 'radioButton'" style="margin-bottom: 15px;">
		          <el-radio-button :label="false">静态数据</el-radio-button>
		          <el-radio-button :label="true">远端数据</el-radio-button>
		        </el-radio-group>
		        
	          <div v-if="item.list.filter(x => x.attrName == 'remote')[0].value">
	            <!-- <el-input size="mini" style="" v-model="el.remoteFunc">
	              <template slot="prepend">远端方法</template>
	            </el-input> -->
	            <!-- <el-input size="mini" style="" v-model="el.props.value">
	              <template slot="prepend">值</template>
	            </el-input>
	            <el-input size="mini" style="" v-model="el.props.label">
	              <template slot="prepend">标签</template>
	            </el-input> -->
              <el-input v-model="el.funcContent">
                <template slot="prepend">请求地址</template>
              </el-input>
              <el-input v-model="el.method">
                <template slot="prepend">请求方式</template>
              </el-input>
              <el-input v-model="el.data">
                <template slot="prepend">请求参数</template>
              </el-input>
              <el-input size="mini" style="" v-model="el.Value">
	              <template slot="prepend">值</template>
	            </el-input>
	            <el-input size="mini" style="" v-model="el.Label">
	              <template slot="prepend">标签</template>
	            </el-input>
	          </div>
		        
		        <div v-else>
		          <template v-if="data.type=='radio' || (data.type=='select'&&!data.options.multiple)">
		            <el-radio-group v-model="data.options.filter(x => x.attrName == 'defaultValue')[0].value">
		              <draggable tag="ul" :list="el.options" 
		                v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
		                handle=".drag-item"
		              >
		                <li v-for="(opt, d) in el.options" :key="d" >
		                  <el-radio :label="opt.value" style="margin-right: 5px;">
		                    <el-input :style="{'width': data.options.filter(x => x.attrName == 'showLabel')[0].value? '90px': '180px' }" size="mini" v-model="opt.value"></el-input>
		                    <el-input style="width:90px;" size="mini" v-if="data.options.filter(x => x.attrName == 'showLabel')[0].value" v-model="opt.label"></el-input>
		                  </el-radio>
		                  <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;"><i class="iconfont icon-icon_bars"></i></i>
		                  <el-button @click="handleOptionsRemove(d)" circle plain type="danger" size="mini" icon="el-icon-minus" style="padding: 4px;margin-left: 5px;"></el-button> 
		                </li>
		              </draggable>
		            </el-radio-group>
		          </template>
		          <template v-else>
		          	<el-checkbox-group v-model="data.options.filter(x => x.attrName == 'defaultValue')[0].value">
		              <draggable tag="ul" :list="el.options" 
		                v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
		                handle=".drag-item"
		              >
		                <li v-for="(opt, d) in el.options" :key="d">
		                  <el-checkbox :label="opt.value" style="margin-right: 5px;">
		                    <el-input :style="{'width': data.options.filter(x => x.attrName == 'showLabel')[0].value? '90px': '180px' }" size="mini" v-model="opt.value"></el-input>
		                    <el-input style="width:90px;" size="mini" v-if="data.options.filter(x => x.attrName == 'showLabel')[0].value" v-model="opt.label"></el-input>
		                  </el-checkbox>
		                  <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;"><i class="iconfont icon-icon_bars"></i></i>
		                  <el-button @click="handleOptionsRemove(d)" circle plain type="danger" size="mini" icon="el-icon-minus" style="padding: 4px;margin-left: 5px;"></el-button> 
		                </li>
		              </draggable>
		           </el-checkbox-group>
		          </template>
		        </div>
		        <div style="margin-left: 22px;">
	            <el-button type="text" @click="handleAddOption">添加选项</el-button>
	          </div>
	        </div>
        </template>
        
        <template v-else-if="item.attrName == 'tabChange'">
        	<ul>
	        	<li v-for="(groupItem,index) in item.group" :key="index">
	        		<i class="drag-item" style="font-size: 16px; margin: 0px 5px; cursor: move;"><i class="iconfont icon-icon_bars"></i></i>
	        		<div class="el-input el-input--mini" style="width: 200px;">
	        			<input type="text" autocomplete="off" placeholder="标签名称" class="el-input__inner" v-model="groupItem.label">
	        		</div>
	        		<button type="button" class="el-button el-button--danger el-button--mini is-plain is-circle" style="padding: 4px; margin-left: 5px;" @click="removeTab(groupItem,item)">
	        			<i class="el-icon-minus"></i>
	        		</button>
	        	</li>
	        </ul>
	        <div style="margin-left: 22px;">
	        	<button type="button" class="el-button el-button--text el-button--small" @click="addTab(item)">
	        	<span>添加标签</span>
	        	</button>
	        </div>
        </template>
        
        <template v-else-if="item.attrName == 'grid'">
        	<draggable tag="ul" :list="item.group" 
            v-bind="{group:{ name:'options'}, ghostClass: 'ghost',handle: '.drag-item'}"
            handle=".drag-item"
          >
            <li v-for="(items, num) in item.group" :key="num" >
              <i class="drag-item" style="font-size: 16px;margin: 0 5px;cursor: move;"><i class="iconfont icon-icon_bars"></i></i>
              <el-input placeholder="栅格值" size="mini" style="width: 100px;" type="number" v-model.number="items.span"></el-input>
              
              <el-button @click="handleOptionsRemove(num)" circle plain type="danger" size="mini" icon="el-icon-minus" style="padding: 4px;margin-left: 5px;"></el-button>
              
            </li>
          </draggable>
          <div style="margin-left: 22px;">
            <el-button type="text" @click="handleAddColumn">添加列</el-button>
          </div>
        </template>

        <template v-else>
          <div v-if="item.type == 'instruction'" v-html="item.memo"></div>

        	<el-input v-if="item.type == 'input'"
                    v-model="item.value"
                    :placeholder="item.placeholder"></el-input>
        	
	        <el-select v-else-if="item.type == 'select'" v-model="item.value" style="width:100%">
	          <el-option v-for="(selects,i) in item.child" :key="i" :label="selects.label" :value="selects.value"></el-option>
	        </el-select>
	        
	        <div v-else-if="item.type == 'checkboxgroup'">
            <el-checkbox-group v-model="item.value">
              <el-checkbox v-for="checkbox in item.child" :label="checkbox.label" :key="checkbox">{{checkbox.label}}</el-checkbox>
            </el-checkbox-group>
	        </div>
	        
	        <div v-else-if="item.type == 'inputNumber'">
	        	<el-input-number v-model="item.value" :min="0" :max="100" :step="1"></el-input-number>
	        </div>
	        
	        <div v-else-if="item.type == 'switch'">
	        	<el-switch v-model="item.value"></el-switch>
	        </div>

          <div v-else-if="item.type == 'checkbox'">
	        	<el-checkbox v-model="item.value">{{item.name}}</el-checkbox>
	        </div>
	        
	        <div v-else-if="item.type == 'radioButton'">
	        	<el-radio-group v-model="item.value">
		          <el-radio-button :label="group.value" v-for="(group,g) in item.groups" :key="g">{{group.label}}</el-radio-button>
		        </el-radio-group>
	        </div>

          <!--对象设置组件渲染-->
          <template v-else-if="item.list && item.list.length>0">
            <div v-for="(_item,n) in item.list" :key="n">
              <span v-show="_item.title">{{_item.title}}</span>
              <widget-config-itme :subArrayItem="_item" :selectIndex="index" :data="data"></widget-config-itme>
            </div>
	        </template>

          <!--设置数组传递-->
          <template v-else-if="item.arrays && item.arrays.length>0">
            <div v-for="(arrayItme,arrayIndex) in item.arrays" :key="arrayIndex">
              <!--数组设置输入框-->
              <div v-if="arrayItme.length>0 && Array.isArray(arrayItme)">
                <div style="padding-left: 20px;box-sizing: border-box;" v-for="(subArrayItem,subArrayItemIndex) in arrayItme" :key="subArrayItemIndex">
                  <span v-show="subArrayItem.title">{{subArrayItem.title}}</span>
                  <widget-config-itme :subArrayItem="subArrayItem" :selectIndex="index"></widget-config-itme>
                </div>
                <!--数组元素删除按钮-->
                <div style="margin-left: 22px">
                  <el-button @click="delXyjArray(index,arrayIndex)"
                             size="mini"
                             type="danger"
                             icon="el-icon-delete"
                             circle
                             :key="arrayIndex">
                  </el-button>
                </div>
              </div>
            </div>
            <div style="text-align:right">
              <el-button size='mini' type="primary" @click="addXyjArray(index)">添加数组元素</el-button>
            </div>
          </template>

          <template v-else-if="item.attrName == 'modelCode'">
            <el-select v-model = "item.value" style="width:100%">
              <el-option v-for="(_modelCode,m) in modelCodes" :key="m" :label="_modelCode.modelName" :value="_modelCode.modelCode"> </el-option>
            </el-select>
          </template>
        </template>
      </el-form-item>
    
    </el-form>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import WidgetConfigItme from './WidgetConfigItme'

export default {
  components: {
    Draggable,
    WidgetConfigItme
  },
  props: ['data'],
  data () {
    return {
      validator: {
        type: null,
        required: null,
        pattern: null,
        range: null,
        length: null
      },
      num:0,
      test:'',
      modelCodes:[]
    }
  },
  computed: {
    show () {
      if (this.data && Object.keys(this.data).length > 0) {
        return true
      }
      return false
    }
  },
  mounted(){
    this.axios({
      url:this.zuul+'/xyj-admin/r/sysFileModel/query',
      method:'post',
      data:{}
    }).then(res => {
      this.modelCodes = res.data.rows
    }).catch(er => {
      console.log(er.message)
    })
  },
  methods: {
    handleOptionsRemove (index) {
      if (this.data.type === 'grid') {
        this.data.options.filter(x => x.attrName == 'grid')[0].group.splice(index, 1)
      } else {
      	this.data.options.filter(x => x.attrName == 'dynamicChange')[0].list[0].options.splice(index, 1)
      }
      
    },
    handleAddOption () {
      if (this.data.options.filter(x => x.attrName == 'showLabel')[0].value) {
        this.data.options.filter(x => x.attrName == 'dynamicChange')[0].list[0].options.push({
          value: '新选项',
          label: '新选项'
        })
      } else {
        this.data.options.filter(x => x.attrName == 'dynamicChange')[0].list[0].options.push({
          value: '新选项'
        })
      }
    },
    /**
     *宋建国：2020/1/10 12:43
     *描述：添加数组元素
     *版本：1.0
     */
    addXyjArray(index){
      let arraylen = this.data.options[index].arrays.length;
      if(arraylen>0){
        let maxData = this.$tu.xyjClone(this.data.options[index].arrays[arraylen-1]);
        this.data.options[index].arrays.push(maxData);
      }
    },
    /**
     *宋建国：2020/1/10 13:08
     *描述：删除数组元素
     *版本：1.0
     */
    delXyjArray(index,i){
      this.data.options[index].arrays.splice(i,1);
    },
    handleAddColumn () {
      this.data.options.filter(x => x.attrName == 'grid')[0].group.push({
        span: '',
        list: []
      })
    },
    generateRule () {
      this.data.rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) {
          this.data.rules.push(this.validator[key])
        }
      })
    },
    handleSelectMuliple (value) {
      if (value) {
        if (this.data.options.defaultValue) {
          this.data.options.defaultValue = [this.data.options.defaultValue]
        } else {
          this.data.options.defaultValue = []
        }
        
      } else {
        if (this.data.options.defaultValue.length>0){
          this.data.options.defaultValue = this.data.options.defaultValue[0]
        } else {
          this.data.options.defaultValue = ''
        }
        
      }
    },

    validateRequired (val,msg) {
      if (val) {
        this.validator.required = {required: true, message:msg?msg: `${this.data.name}必须填写`}
      } else {
        this.validator.required = null
      }

      this.$nextTick(() => {
        this.generateRule()
      })
    },

    validateDataType (val,msg) {
      if (!this.show) {
        return false
      }
      
      if (val) {
        this.validator.type = {type: val, message: msg ? msg : this.data.name + '格式不正确'}
      } else {
        this.validator.type = null
      }

      this.generateRule()
    },
    valiatePattern (val,msg) {
      if (!this.show) {
        return false
      }

      if (val) {
        this.validator.pattern = {pattern: val, message: msg ? msg : this.data.name + '格式不匹配'}
      } else {
        this.validator.pattern = null
      }

      this.generateRule()
    },
    addTab(targetName) {
      targetName.group.push({
        label: "标签页",
				list: [],
				name: "标签页" + this.num++
      });
      targetName.defaultValue = targetName.group[targetName.group.length-1].name
    },
    removeTab(targetName,tabs){
    	for(var i=0;i<tabs.group.length;i++){
    		if(tabs.group[i].name == targetName.name){
    			tabs.group.splice(i,1)
    		}
    	}
    	tabs.defaultValue = tabs.group[tabs.group.length-1].name
    }
  },
  watch: {
  	'data.options':{
  		handler(val){
  			if(this.data && val && this.data.options.filter(x => x.attrName == "isRange").length>0){
  				if (typeof this.data.options.filter(x => x.attrName == "isRange")[0].value !== 'undefined') {
		        if (this.data.options.filter(x => x.attrName == "isRange")[0].value) {
		          this.data.options.filter(x => x.attrName == 'defaultValue')[0].value = null
		        } else {
		          if (Object.keys(this.data.options).indexOf('defaultValue')>=0) 
		            this.data.options.filter(x => x.attrName == 'defaultValue')[0].value = ''
		        }
		      }
        }
  			if(this.data && val && this.data.options.filter(x => x.attrName == 'regex').length > 0){	
  				if(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'required').length>0){
            let reqmsg = this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'errormsg')[0].value
  					this.validateRequired(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'required')[0].value,reqmsg)
          }
          if(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType').length>0){
            let datamsg = this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'errormsg')[0].value
  					this.validateDataType(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType')[0].value,datamsg)
          }
          if(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'pattern').length>0){
            let patmsg = this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'errormsg')[0].value
  					this.valiatePattern(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'pattern')[0].value,patmsg)
  				}
  			}	
  		},
  		deep:true
  	},
    'data.name': function (val) {
      if (this.data && this.data.options && this.data.options.filter(x => x.attrName == 'regex').length > 0) {
      	if(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'required').length>0){      
          let reqmsg = this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'errormsg')[0].value		
      		this.validateRequired(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'required')[0].value,reqmsg)
        }
        if(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType').length>0){
          let datamsg = this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'errormsg')[0].value
      		this.validateDataType(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType')[0].value,datamsg)
        }
        if(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'pattern').length>0){
          let patmsg = this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'errormsg')[0].value
      		this.valiatePattern(this.data.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'pattern')[0].value,patmsg)
      	}
      }
    },
    'data.group': function (val){
    	console.log(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vueformmaking/WidgetConfig.vue